<script setup>
import imageHelper from '@/Helpers/image_helper.js';

const { getImage } = imageHelper.methods;

const props = defineProps({
    icon: {
        type: String,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    description: {
        type: String,
        required: true
    }
});
</script>

<template>
    <ul class="contentBox group shadow-article bg-white w-full">
        <li class="w-full h-full">
            <div class="innerPoint w-full h-full">
                <div class="benefitsPoint w-full h-full flex flex-col justify-start items-center gap-y-3">
                    <div
                        class="block p-4 md:p-6 rounded-full bg-grayArticleColor/80 transition-transform duration-500 ease-in-out bg-icon">
                        <img class="h-8 md:h-10" :src="getImage(props.icon)" alt="Icon Services">
                    </div>
                    <h1 class="text-title-content-sub text-center leading-7">{{ props.title }}</h1>
                    <p class="text-description text-grayBlackColor text-center w-5/6 md:line-clamp-4">
                        {{ props.description }}
                    </p>
                </div>
            </div>
        </li>
    </ul>
</template>

<style scoped>
@media (min-width: 641px) {
    article:hover {
        transform: translateY(-10px);
    }

    article:hover div {
        transform: scaleX(-1);
    }
}

.contentBox {
    transition: background-color 0.2s ease, color 0.2s ease;
}

@media (min-width: 641px) {
    .contentBox:hover {
        background-color: #577BE9;
    }

    .contentBox:hover .benefitsPoint .bg-icon {
        background-color: white;
    }

    .contentBox:hover .benefitsPoint span,
    .contentBox:hover .benefitsPoint h1,
    .contentBox:hover .benefitsPoint p {
        color: white;
    }
}

.contentBox li {
    border: 1px solid #577BE9;
    position: relative;
}

.contentBox li::before {
    content: "";
    position: absolute;
    top: auto;
    bottom: -28px;
    left: -11px;
    right: auto;
    width: 0;
    right: -12px;
    height: 0;
    border-top: 32px solid transparent;
    border-left: 30px solid #577BE9;
    border-bottom: 30px solid transparent;
    scale: .4;
    display: inline-block;
    transform: rotate(134deg);
    z-index: 1;

}

.contentBox li::after {
    content: "";
    position: absolute;
    top: -28px;
    left: auto;
    width: 0;
    right: -12px;
    height: 0;
    border-top: 32px solid transparent;
    border-left: 30px solid #577BE9;
    border-bottom: 30px solid transparent;
    scale: .4;
    display: inline-block;
    transform: rotate(-45deg);
}

.contentBox li .innerPoint {
    position: relative;
}

.contentBox li .innerPoint::before {
    content: "";
    position: absolute;
    top: auto;
    bottom: -26px;
    left: -9px;
    width: 0;
    right: auto;
    height: 0;
    border-top: 32px solid transparent;
    border-left: 30px solid #577BE9;
    border-bottom: 30px solid transparent;
    scale: .5;
    display: inline-block;
    transform: rotate(134deg);
}

.contentBox li .innerPoint::after {
    content: "";
    position: absolute;
    top: auto;
    bottom: -28px;
    left: -11px;
    width: 0;
    right: auto;
    height: 0;
    border-top: 32px solid transparent;
    border-left: 30px solid #F8F8F8;
    border-bottom: 30px solid transparent;
    scale: .6;
    display: inline-block;
    transform: rotate(134deg);
}

.contentBox li .innerPoint .benefitsPoint {
    position: relative;
    padding: 20px;
}

.contentBox li .innerPoint .benefitsPoint::before {
    content: "";
    position: absolute;
    top: -26px;
    left: auto;
    width: 0;
    right: -10px;
    height: 0;
    border-top: 32px solid transparent;
    border-left: 30px solid #577BE9;
    border-bottom: 30px solid transparent;
    scale: .5;
    display: inline-block;
    transform: rotate(-45deg);
}

.contentBox li .innerPoint .benefitsPoint::after {
    content: "";
    position: absolute;
    top: -28px;
    left: auto;
    width: 0;
    right: -10px;
    height: 0;
    border-top: 33px solid transparent;
    border-left: 30px solid #F8F8F8;
    border-bottom: 31px solid transparent;
    scale: .5;
    display: inline-block;
    transform: rotate(-45deg);
}

.contentBox li .innerPoint .benefitsPoint span {
    color: #ebebeb;
    display: inline-block;
}
</style>
